/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "flagmetricsexp": {
        "nested": {
          "message": {
            "nested": {
              "Prerequisite": {
                "fields": {
                  "flagKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "required"
                  },
                  "evaluationReason": {
                    "type": ".squareup.flagmetricsexp.message.EvaluationReason",
                    "id": 2,
                    "rule": "required"
                  },
                  "stringValue": {
                    "type": "string",
                    "id": 3
                  },
                  "intValue": {
                    "type": "int32",
                    "id": 4
                  },
                  "boolValue": {
                    "type": "bool",
                    "id": 5
                  },
                  "doubleValue": {
                    "type": "double",
                    "id": 6
                  }
                },
                "nested": {
                  "value": {
                    "oneof": [
                      "stringValue",
                      "intValue",
                      "boolValue",
                      "doubleValue"
                    ]
                  }
                }
              },
              "EvaluationReason": {
                "fields": {
                  "kind": {
                    "type": ".squareup.flagmetricsexp.message.EvaluationReason.Kind",
                    "id": 1,
                    "rule": "required"
                  },
                  "ruleMatch": {
                    "type": ".squareup.flagmetricsexp.message.EvaluationReason.RuleMatchDetails",
                    "id": 10
                  },
                  "prereqFailed": {
                    "type": ".squareup.flagmetricsexp.message.EvaluationReason.PrerequisiteFailDetails",
                    "id": 11
                  },
                  "fallthrough": {
                    "type": ".squareup.flagmetricsexp.message.EvaluationReason.FallthroughDetails",
                    "id": 12
                  }
                },
                "nested": {
                  "Kind": {
                    "values": {
                      "UNKNOWN": 0,
                      "OFF": 1,
                      "TARGET_MATCH": 2,
                      "RULE_MATCH": 3,
                      "FALLTHROUGH": 4,
                      "PREREQUISITE_FAILED": 5
                    }
                  },
                  "RuleMatchDetails": {
                    "fields": {
                      "ruleId": {
                        "type": "string",
                        "id": 1,
                        "rule": "required"
                      },
                      "inExperiment": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "PrerequisiteFailDetails": {
                    "fields": {
                      "prerequisiteKey": {
                        "type": "string",
                        "id": 1,
                        "rule": "required"
                      }
                    }
                  },
                  "FallthroughDetails": {
                    "fields": {
                      "inExperiment": {
                        "type": "bool",
                        "id": 1,
                        "rule": "required"
                      }
                    }
                  },
                  "detail": {
                    "oneof": [
                      "ruleMatch",
                      "prereqFailed",
                      "fallthrough"
                    ]
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.flagmetricsexp?.nested?.message?.nested?.Prerequisite && !$root.nested?.squareup?.nested?.flagmetricsexp?.nested?.message?.nested?.EvaluationReason && !$root.nested?.squareup?.nested?.flagmetricsexp?.nested?.message?.nested?.EvaluationReason?.nested?.Kind && !$root.nested?.squareup?.nested?.flagmetricsexp?.nested?.message?.nested?.EvaluationReason?.nested?.RuleMatchDetails && !$root.nested?.squareup?.nested?.flagmetricsexp?.nested?.message?.nested?.EvaluationReason?.nested?.PrerequisiteFailDetails && !$root.nested?.squareup?.nested?.flagmetricsexp?.nested?.message?.nested?.EvaluationReason?.nested?.FallthroughDetails) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE Prerequisite @ squareup/flagmetricsexp/message/flag_evaluation_details.proto at 8:1
 */
export const Prerequisite = $root.lookupType('squareup.flagmetricsexp.message.Prerequisite');
fixType(Prerequisite);
Builder.createAndAttachToType(Prerequisite);
/**
 * SOURCE EvaluationReason @ squareup/flagmetricsexp/message/flag_evaluation_details.proto at 19:1
 */
export const EvaluationReason = $root.lookupType('squareup.flagmetricsexp.message.EvaluationReason');
fixType(EvaluationReason);
Builder.createAndAttachToType(EvaluationReason);
/**
 * SOURCE Kind @ squareup/flagmetricsexp/message/flag_evaluation_details.proto at 20:3
 */
EvaluationReason.Kind = $root.lookupEnum('squareup.flagmetricsexp.message.EvaluationReason.Kind').values;
/**
 * SOURCE RuleMatchDetails @ squareup/flagmetricsexp/message/flag_evaluation_details.proto at 37:3
 */
EvaluationReason.RuleMatchDetails = $root.lookupType('squareup.flagmetricsexp.message.EvaluationReason.RuleMatchDetails');
fixType(EvaluationReason.RuleMatchDetails);
Builder.createAndAttachToType(EvaluationReason.RuleMatchDetails);
/**
 * SOURCE PrerequisiteFailDetails @ squareup/flagmetricsexp/message/flag_evaluation_details.proto at 42:3
 */
EvaluationReason.PrerequisiteFailDetails = $root.lookupType('squareup.flagmetricsexp.message.EvaluationReason.PrerequisiteFailDetails');
fixType(EvaluationReason.PrerequisiteFailDetails);
Builder.createAndAttachToType(EvaluationReason.PrerequisiteFailDetails);
/**
 * SOURCE FallthroughDetails @ squareup/flagmetricsexp/message/flag_evaluation_details.proto at 46:3
 */
EvaluationReason.FallthroughDetails = $root.lookupType('squareup.flagmetricsexp.message.EvaluationReason.FallthroughDetails');
fixType(EvaluationReason.FallthroughDetails);
Builder.createAndAttachToType(EvaluationReason.FallthroughDetails);
